import { render } from "./MobileNavMenuItem.vue?vue&type=template&id=4d9e6051&scoped=true&ts=true"
import script from "./MobileNavMenuItem.vue?vue&type=script&lang=ts"
export * from "./MobileNavMenuItem.vue?vue&type=script&lang=ts"

import "./MobileNavMenuItem.vue?vue&type=style&index=0&id=4d9e6051&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9e6051"]])

export default __exports__